import { useEffect, useState } from "react";

const useServiceCategories = (token, update) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}api/admin/service-categories?limit=100`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const json = await response.json();

        if (response.ok) {
          setCategories(json.data.categories || []);
        }
      } catch (error) {
        console.error("Error fetching service categories:", error);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchCategories();
    }
  }, [token, update]);

  return { categories, loading, setCategories };
};

export default useServiceCategories;